module.exports = __webpack_public_path__ + "static/media/llanta-desgaste.ca09a338.svg";